import { IconCheckboxSelected, IconCheckboxIndeterminate, IconCheckboxUnselected } from '@hubble/icons/web';
import { forwardRef } from 'react';
import { BaseSwitch } from '../shared/components/BaseSwitch/index.js';
import { jsx } from '@emotion/react/jsx-runtime';

const Checkbox = forwardRef((props, ref) => jsx(BaseSwitch, {
  iconSelected: jsx(IconCheckboxSelected, {}),
  iconIndeterminate: jsx(IconCheckboxIndeterminate, {}),
  iconUnselected: jsx(IconCheckboxUnselected, {}),
  inputType: "checkbox",
  ref: ref,
  ...props,
  children: props.children
}));

export { Checkbox };
